/**
 * Copyright (c) 2019 7thCode.(http://seventh-code.com/)
 * This software is released under the MIT License.
 * opensource.org/licenses/mit-license.php
 */

"use strict";

import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Callback, IErrorObject} from "../../../../types/platform/universe";
import {retry} from "rxjs/operators";

import {PublicKeyService} from "../../platform/base/services/publickey.service";
import {HttpService} from "../../platform/base/services/http.service";
import {Errors} from "../base/library/errors";
import {TranslateService} from "@ngx-translate/core";

/**
 * todo
 */
@Injectable({
	providedIn: "root",
})

export class PaymentService extends HttpService {

	/**
	 *
	 * @param http
	 * @param PublicKey
	 */
	constructor(
		public http: HttpClient,
		private PublicKey: PublicKeyService,
	) {
		super(http);
	}

	/*
	* @param key 公開鍵
	* @param plain 原文
	* @param callback 暗号を返すコールバック
	*/
	private static publickey_encrypt(key: string, plain: string, callback: Callback<any>): void {
		try {
			// 	const rsa: NodeRSA = new NodeRSA(key, "pkcs1-public-pem", {encryptionScheme: "pkcs1_oaep"});
			// 	callback(null, rsa.encrypt(plain, "base64"));
			callback(null, plain);
		} catch (error: any) {
			callback(error, "");
		}
	}

	/**
	 * 公開鍵暗号
	 *
	 * @param key 公開鍵
	 * @param plain 原文
	 * @param callback 暗号を返すコールバック
	 */
	private value_encrypt(key: string, plain: object, callback: Callback<any>) {
		try {
			PaymentService.publickey_encrypt(key, JSON.stringify(plain), (error, encryptedText): void => {
				if (!error) {
					callback(null, encryptedText);
				} else {
					callback(error, "");
				}
			});
		} catch (error: any) {
			callback(error, "");
		}
	}

	/**
	 * @returns none
	 */
	protected decorator(value: any): any {
		return value;
	}

	/**
	 * is カスタマー
	 *
	 * @param callback コールバック
	 */
	public isCustomer(callback: Callback<any>): void {
		this.http.get(this.endPoint + '/stripe/iscustomer', this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00376"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00377"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/**
	 * 課金
	 *
	 * @param callback コールバック
	 * @param username
	 */
	public isSubscribeUser(username: string, callback: Callback<any>): void {
		this.http.get(this.endPoint + '/stripe/issubscribe/' + username, this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(Errors.serverError(result, "A00160"), null);
						}
					} else {
						callback(Errors.httpError(500, "A00161"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00162"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/**
	 * カスタマークリエイト
	 *
	 * @param content　クリエイトデータ
	 * @param callback コールバック
	 */
	public createCustomer(content: any, callback: Callback<any>): void {
		this.http.post(this.endPoint + "/stripe/customer/create", content, this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00378"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00379"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/**
	 * 単一のオブジェクトを返す
	 *
	 * @param id オブジェクトID
	 * @param callback オブジェクトを返すコールバック
	 */
	public retrieveCustomer(callback: Callback<object>): void {
		this.http.get(this.endPoint + "/stripe/customer/retrieve", this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, this.decorator(result.value));
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00380"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00381"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/**
	 *
	 * @param id
	 * @param content
	 * @param callback
	 */
	public updateCustomer(content: any, callback: Callback<any>): void {
		this.http.put(this.endPoint + "/stripe/customer/update", content, this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00382"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00383"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/**
	 * レコード削除
	 *
	 * @param id 削除レコードID
	 * @param callback コールバック
	 */
	public deleteCustomer(callback: Callback<any>): void {
		this.http.delete(this.endPoint + "/stripe/customer/delete", this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00384"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00385"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/*
	*
	*  code 0: OK
	*  code 1: no customer
	*  else error
	*
	 * @param id
	 * @param content
	 * @param callback
	 */
	public createSource(content: any, callback: Callback<any>): void {
		this.PublicKey.fixed((error, key): void => {
			if (!error) {
				this.value_encrypt(key, content, (error: IErrorObject, value: any): void => {
					if (!error) {
						this.http.post(this.endPoint + "/stripe/source/create", {content: value}, this.httpOptions).pipe(retry(3)).subscribe(
							{
								next: (result: any): void => {
									if (this.isNumber(result.code)) {
										// 1: no customer
										if (result.code === 0) {
											callback(null, result);
										} else {
											callback(result, null);
										}
									} else {
										callback(Errors.httpError(500, "A00386"), null);
									}
								},
								error: (error: HttpErrorResponse): void => {
									callback(Errors.socketError(error, "A00387"), null);
								},
								complete: () => {
								}
							}
						);
					} else {
						callback(Errors.generalError(error.code, error.message, "A00174"), null);
					}
				});
			} else {
				callback(Errors.generalError(error.code, error.message, "A00174"), null);
			}
		});
	}

	/*
	 * @param id
	 * @param content
	 * @param callback
	 */
	public retrieveSource(index: number, callback: Callback<any>): void {
		this.http.get(this.endPoint + "/stripe/source/retrieve/" + index, this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00388"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00389"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/*
	 * @param id
	 * @param content
	 * @param callback
	 */
	public updateSource(index: number, content: any, callback: Callback<any>): void {
		this.http.put(this.endPoint + "/stripe/source/update/" + index, content, this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00390"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00391"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/*
 * @param id
 * @param content
 * @param callback
 */
	public deleteSource(card_id: string, callback: Callback<any>): void {
		this.http.delete(this.endPoint + "/stripe/source/delete/" + card_id, this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00392"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00393"), null);
				},
				complete: () => {
				}
			}
		);
	}


	/**
	 * チャージ
	 *
	 * @param content　クリエイトデータ
	 * @param callback コールバック
	 * locale
	 */
	public charge(content: any, callback: Callback<any>): void {
		const lang = localStorage.getItem("language");
		content.lang = lang;
		this.http.post(this.endPoint + "/stripe/charge", content, this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00426"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00427"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/**
	 * 定期
	 *
	 * https://dashboard.stripe.com/test/products/create
	 *
	 * @param content　クリエイトデータ
	 * @param callback コールバック
	 */
	public subscribe(content: any, callback: Callback<any>): void {
		this.http.post(this.endPoint + "/stripe/subscribe", content, this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00394"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "A00395"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/**
	 * 定期
	 *
	 * https://dashboard.stripe.com/test/products/create
	 *
	 * @param content　クリエイトデータ
	 * @param callback コールバック
	 */
	public is_subscribe(callback: Callback<any>): void {
		this.http.get(this.endPoint + "/stripe/subscribe", this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "0000"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "1234"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/**
	 * 定期
	 *
	 * https://dashboard.stripe.com/test/products/create
	 *
	 * @param content　クリエイトデータ
	 * @param callback コールバック
	 */
	public update_subscribe(content: any, callback: Callback<any>): void {
		this.http.put(this.endPoint + "/stripe/subscribe", content, this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00321"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.socketError(error, "1234"), null);
				},
				complete: () => {
				}
			}
		);
	}

	/**
	 * 定期
	 *
	 * https://dashboard.stripe.com/test/products/create
	 *
	 * @param content　クリエイトデータ
	 * @param callback コールバック
	 */
	public cancel_subscribe(callback: Callback<any>): void {
		this.http.delete(this.endPoint + "/stripe/subscribe", this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00322"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.networkException(error, "1234"), null);
				},
				complete: () => {
				}
			}
		);
	}

		/**
	 * 定期
	 *
	 * https://dashboard.stripe.com/test/products/create
	 *
	 * @param content　クリエイトデータ
	 * @param callback コールバック
	 */
	public cancel_subscribe_at(account: any, callback: Callback<any>): void {
		this.http.delete(this.endPoint + "/stripe/subscribe/" + account.user_id , this.httpOptions).pipe(retry(3)).subscribe(
			{
				next: (result: any): void => {
					if (this.isNumber(result.code)) {
						if (result.code === 0) {
							callback(null, result.value);
						} else {
							callback(result, null);
						}
					} else {
						callback(Errors.httpError(500, "A00323"), null);
					}
				},
				error: (error: HttpErrorResponse): void => {
					callback(Errors.networkException(error, "1234"), null);
				},
				complete: () => {
				}
			}
		);
	}

}
